import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { assets } from "../../../assets/assets";
import { MARKETING_ACTIONS, MARKETING_NAV_LINKS } from "../../../config/marketing/navigation";
import { Button } from "../../../components/common/button";

export default function MarketingNavbar() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <header className="w-full bg-black">
            <nav className="mx-auto flex h-16 items-center px-8">
                {/* Logo */}
                <img src={assets.booking_logo} alt="Eikos Health" className="h-24 w-auto" />

                {/* Desktop nav */}
                <ul className="ml-12 hidden items-center gap-8 md:flex">
                    {MARKETING_NAV_LINKS.map((link) => (
                        <li key={link.label}>
                            <a
                                href={link.href}
                                className="text-sm font-medium text-text-inverse/70 hover:text-text-inverse transition"
                            >
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>

                {/* Desktop actions */}
                <div className="ml-auto hidden items-center gap-3 md:flex">
                    <a
                        href={MARKETING_ACTIONS.contact.href}
                        className="text-sm text-text-inverse/70 hover:text-text-inverse transition"
                    >
                        {MARKETING_ACTIONS.contact.label}
                    </a>

                    <Button size="sm" onClick={() => (window.location.href = MARKETING_ACTIONS.login.href)}>
                        {MARKETING_ACTIONS.login.label}
                    </Button>

                    <Button
                        size="sm"
                        variant="secondary"
                        onClick={() => (window.location.href = MARKETING_ACTIONS.cta.href)}
                    >
                        {MARKETING_ACTIONS.cta.label}
                    </Button>
                </div>

                {/* Mobile hamburger */}
                <button
                    aria-label="Toggle navigation"
                    onClick={() => setOpen(true)}
                    className="ml-auto text-text-inverse md:hidden"
                >
                    <Menu />
                </button>
            </nav>

            {/* Mobile menu */}
            {open && <MobileMenu open={open} setOpen={setOpen} />}
        </header>
    );
}

function MobileMenu({ open, setOpen }: { open: boolean; setOpen: React.Dispatch<React.SetStateAction<boolean>> }) {
    return (
        <div className="fixed inset-0 z-50 bg-black">
            <div className="flex h-16 items-center justify-between px-6">
                <img src={assets.booking_logo} className="h-24" />
                <button aria-label="Close navigation" onClick={() => setOpen(false)} className="text-text-inverse">
                    <X />
                </button>
            </div>

            <div className="mt-8 flex flex-col gap-6 px-6">
                {MARKETING_NAV_LINKS.map((link) => (
                    <a
                        key={link.label}
                        href={link.href}
                        className="text-lg text-text-inverse"
                        onClick={() => setOpen(false)}
                    >
                        {link.label}
                    </a>
                ))}

                <div className="mt-6 flex flex-col gap-4">
                    <Button variant="secondary" onClick={() => (window.location.href = MARKETING_ACTIONS.login.href)}>
                        {MARKETING_ACTIONS.login.label}
                    </Button>

                    <Button onClick={() => (window.location.href = MARKETING_ACTIONS.cta.href)}>
                        {MARKETING_ACTIONS.cta.label}
                    </Button>
                </div>
            </div>
        </div>
    );
}
